/**
 * INSOLIP Landing Page – full composition from Project Landing Page
 */
import { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TargetClients } from './components/TargetClients';
import { WhyUs } from './components/WhyUs';
import { Stats } from './components/Stats';
import { About } from './components/About';
import { Features } from './components/Features';
import { Services } from './components/Services';
import { Team } from './components/Team';
import { Partners } from './components/Partners';
import { News } from './components/News';
import { Contact } from './components/Contact';
import { Modal } from './components/Modal';
import { Footer } from './components/Footer';

export interface LandingPageProps {
  onGetStarted: () => void;
}

export function LandingPage({ onGetStarted }: LandingPageProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="landing-page min-h-screen bg-[var(--navy)]">
      <Navbar onCTAClick={onGetStarted} />
      <Hero onPrimaryCTA={onGetStarted} />
      <TargetClients />
      <WhyUs />
      <Stats />
      <About />
      <Features />
      <Services />
      <Team />
      <Partners />
      <News onGetStarted={onGetStarted} />
      <Contact />
      <Footer onAccessPlatform={onGetStarted} />
      <Modal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
}
